import classNames from 'classnames/bind'

import InsuranceDetailWrapper from '$components/insurance/my/detail/InsuranceDetailWrapper'

import Styles from './InsuranceDetailArticleWrapper.module.scss'

import type {보장상세_탭} from '$share/constants/insurance'
import type {ValueOf} from 'next/constants'
import type {PropsWithChildren} from 'react'

const cx = classNames.bind(Styles)

export default function InsuranceDetailArticleWrapper({
    id,
    expired,
    children,
}: PropsWithChildren<{
    id: ValueOf<typeof 보장상세_탭>
    isFreeInsurance?: boolean
    expired?: boolean
}>) {
    if (expired) {
        return <div id={id} className={cx('article', 'expired')} />
    }

    return (
        <InsuranceDetailWrapper id={id}>
            <div className={cx('article')}>{children}</div>
        </InsuranceDetailWrapper>
    )
}
